module.exports = __webpack_public_path__ + "media/components/country-flag/static/hk-05e199a69ebae349ac87e1758e8ea1d9.svg";